import { FunctionComponent } from "react";
import AccessRestricted from "./access-restricted";
import getDashboardRoute from "./get-dashboard-route";
import Permissions from "./permissions";
import useGuarded from "./use-guarded";

export interface GuardedProps {
  preventSuperAdminAccess?: boolean;
  onlySuperAdminAccess?: boolean;
  permissions?: Permissions[];
  children: JSX.Element;
}

const GuardedRoute: FunctionComponent<GuardedProps> = ({
  permissions,
  children,
  preventSuperAdminAccess,
  onlySuperAdminAccess,
}) => {
  const allowed = useGuarded(
    permissions,
    preventSuperAdminAccess,
    onlySuperAdminAccess
  );
  if (allowed) {
    return children;
  }
  return <AccessRestricted homePage={getDashboardRoute({})} />;
};

export default GuardedRoute;
